import ActionCable from "actioncable";

let connection = null;

const socket =
  process.env.NODE_ENV === "development"
    ? process.env.WEBSOCKET
    : `wss://${window.location.host.replace("www.", "")}/websocket`;

export function initialize(store) {
  if (!connection) {
    connection = {
      store,
      cable: ActionCable.createConsumer(socket)
    };
  }
}

export default function cable() {
  if (!connection) {
    throw new Error("Connection not established");
  }

  return connection;
}

export function createChannel(bridge = cable()) {
  function disconnect(onDisconnect = () => {}) {
    return function disconnected() {
      this.unsubscribe();
      onDisconnect(bridge.store);
    };
  }

  function listen(name, { onDisconnect = () => {}, onReceive = () => {} }) {
    return bridge.cable.subscriptions.create(name, {
      disconnected: disconnect(onDisconnect),
      received: onReceive
    });
  }

  return { listen, disconnect };
}



// WEBPACK FOOTER //
// ./app/cable.js